'use strict';

var React = require('react'),
    Title = require('./Title'),
    _ = require('lodash');

var SectionTitle = React.createClass({
	displayName: 'SectionTitle',


	propTypes: {
		title: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
		align: React.PropTypes.string, // LEFT / RIGHT / BOTH / NONE
		className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
	},

	getDefaultProps: function getDefaultProps() {
		return {
			title: '-',
			align: 'RIGHT'
		};
	},

	render: function render() {
		var className = _.concat(['section-title', 'fields-tbl', 'f-t-middle'], this.props.className),
		    before = '',
		    after = '';

		if (_.toLower(this.props.align) == 'left' || _.toLower(this.props.align) == 'both') {
			before = React.createElement(
				'div',
				{ className: 'f-d-align-left' },
				this.props.children
			);
		}

		if (_.toLower(this.props.align) == 'right' || _.toLower(this.props.align) == 'both') {
			after = React.createElement(
				'div',
				{ className: 'f-d-align-right' },
				this.props.children
			);
		}

		return React.createElement(
			'div',
			{ className: className.join(' ') },
			before,
			React.createElement(
				'div',
				{ className: 's-t-title' },
				React.createElement(Title, _.omit(this.props, 'align'))
			),
			after
		);
	}

});

module.exports = SectionTitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Title/SectionTitle.js
// module id = 449
// module chunks = 0 1 2 3 5 7 8 9 11 13 14 16 17 18 21 23 25 28